var $ = require('jquery');
require('fg-frontend/edeeshop/jquery.magnify');

/*************************************************************
 * Magnify activate and deactivate
 */
window.activeZoom = window.activeZoom || null;

var destroyZoom = function(anchor, instance) {
	instance.destroy();
	anchor.removeClass('zoom-out').addClass('zoom-in');
	anchor.removeClass('js_image-magnify-deactivate').addClass('js_image-magnify-activate');
	window.activeZoom = null;
};

// activate on zoom in
$(document).on('click', '.js_image-magnify-activate', function (event) {
	var $a = $(event.target);
	$a.data('magnifyInstance', $('.product-photogallery li.active img').magnify());
	$a.removeClass('zoom-in').addClass('zoom-out');
	$a.removeClass('js_image-magnify-activate').addClass('js_image-magnify-deactivate');
	window.activeZoom = $a;
});

// deactivate on zoom out
$(document).on('click', '.js_image-magnify-deactivate', function (event) {
	destroyZoom($(event.target), $(event.target).data('magnifyInstance'));
});

// deactivate on slide change
$(document).on('EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE', function(event) {
	var $a = window.activeZoom;
	if ($a instanceof $) {
		destroyZoom($a, window.activeZoom.data('magnifyInstance'));
	}
});

// deactivate on escape key
$(document).on('keyup', function(event) {
	var $a = window.activeZoom;
	// 27 = escape
	if ($a instanceof $ && event.which == 27) {
		destroyZoom($a, $a.data('magnifyInstance'));
	}
});


// WEBPACK FOOTER //
// ./config/module-publish/resources/js/eshop-widgets/support-magnify.js